import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getRegulationsStagesPlanWorksRecomendedCounterparties: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_COUNTERPARTIES].GET_REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_COUNTERPARTIES,
	},
}